var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"ui-input-base-radio",class:{
        _active: _vm.checked,
        _disabled: _vm.isDisabled,
    }},[_c('input',{staticClass:"ui-input-base-radio__input",attrs:{"type":"radio","name":_vm.name,"disabled":_vm.isDisabled},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.updateModel($event.target.checked)}}}),_c('div',{staticClass:"ui-input-base-radio__check"})])
}
var staticRenderFns = []

export { render, staticRenderFns }